import React from 'react';

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="footer-content">
                    <div className="footer-column">
                        <h3>Thaksha</h3>
                        <p>Thaksha Architects began in 2009, and is a total service of architectural firm skilled in the art and science of designing unique environment for living, learning, work and recreation</p>
                        <div className="social-links">
                            <a href="https://www.facebook.com/share/14G3XbK9zo2/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                            <a href="#"><i className="fab fa-twitter"></i></a>
                            <a href="https://www.instagram.com/thakshaarchitects?igsh=b2k4ZDZjaXJoaHVi" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                            <a href="#"><i className="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                    
                    <div className="footer-column">
                        <h3>Contact Info</h3>
                        <p><i className="fas fa-map-marker-alt"></i> Kavitha Road ,Kacherithazham , Muvattupuzha, Ernakulam-686661, Kerala, India</p>
                        <p><i className="fas fa-phone"></i> +91 97456 95978</p>
                        <p><i className="fas fa-envelope"></i> r4rubense@gmail.com</p>
                    </div>
                </div>
                <div className="copyright">
                    <p>&copy; 2025 Thaksha. All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;